import React from 'react';
import PropTypes from 'prop-types';

import ErrorMessageConstants from 'app/shared/constants/ErrorMessageConstants';
import KeyCodeConstants from 'app/shared/constants/KeyCodeConstants';

import {
    Button,
    ButtonGroup,
    Flex,
    Spacer,
    TextButton,
    Text,
} from '@zillow/constellation';

const propTypes = {
    onCancel: PropTypes.func,
    onSubmit: PropTypes.func.isRequired,
    submitText: PropTypes.string,
    cancelText: PropTypes.string,
    errorMessage: PropTypes.string,
    isSubmitting: PropTypes.bool,
    hasError: PropTypes.bool,
    isSubmitDisabled: PropTypes.bool,
};

const defaultProps = {
    onCancel: null,
    submitText: 'Confirm',
    cancelText: 'Cancel',
    errorMessage: '',
    isSubmitting: false,
    hasError: false,
    isSubmitDisabled: false,
};

const onKeyUp = (event) => {
    if (event.keyCode === KeyCodeConstants.ENTER ||
        event.keyCode === KeyCodeConstants.SPACE) {
        event.target.click();
    }
};

const ModalFooter = ({
    onCancel,
    onSubmit,
    submitText,
    cancelText,
    errorMessage,
    isSubmitting,
    hasError,
    isSubmitDisabled,
}) => (
    <Flex display="flex" flexDirection="column" alignItems="flex-end">
        {hasError && (
            <Spacer paddingBottom="sm">
                <Text fontColor="red600">{errorMessage || ErrorMessageConstants.DEFAULT_ERROR}</Text>
            </Spacer>
        )}
        <ButtonGroup aria-label="controls">
            {onCancel && (
                <TextButton
                    aria-label="Cancel"
                    tabIndex={0}
                    buttonType="primary"
                    onClick={onCancel}
                    onKeyUp={onKeyUp}
                    disabled={isSubmitting}
                >
                    {cancelText}
                </TextButton>
            )}
            <Button
                buttonType="primary"
                onClick={onSubmit}
                disabled={isSubmitting || isSubmitDisabled}
            >
                {submitText}
            </Button>
        </ButtonGroup>
    </Flex>
);

ModalFooter.propTypes = propTypes;
ModalFooter.defaultProps = defaultProps;

export default ModalFooter;
